// Centralised date formatting locked to the True Global office timezone
// (America/Vancouver — automatically handles PST/PDT switches).
const TZ = 'America/Vancouver';

// MongoDB serialises datetimes as naive ISO strings ("2026-05-28T21:54:28.459000")
// with NO timezone suffix. JavaScript's `new Date(str)` then mis-reads them as
// the viewer's local time. Backend stores everything as UTC, so we normalise
// any timezone-less ISO string to UTC by appending "Z" before parsing.
function toUtcDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  let s = String(value);
  // Already has explicit offset / Z → leave alone.
  if (/Z$|[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
  // Strip sub-millisecond precision (e.g. ".459000" → ".459") which some
  // JS engines on iOS reject, then append Z to flag as UTC.
  s = s.replace(/(\.\d{3})\d+$/, '$1') + 'Z';
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function fmtDateTime(value) {
  const d = toUtcDate(value);
  if (!d) return '—';
  return d.toLocaleString('en-CA', {
    timeZone: TZ,
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}

export function fmtDate(value) {
  const d = toUtcDate(value);
  if (!d) return '—';
  return d.toLocaleDateString('en-CA', {
    timeZone: TZ,
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
}

export function fmtShort(value, opts = {}) {
  const d = toUtcDate(value);
  if (!d) return '—';
  return d.toLocaleDateString('en-CA', {
    timeZone: TZ,
    month: opts.month || 'short',
    day: opts.day || 'numeric',
  });
}

// Exposed for any callsite that does its own .toLocaleString() and needs the
// same UTC-aware Date parsing.
export const parseUtc = toUtcDate;

export const OFFICE_TZ = TZ;
